export default __webpack_public_path__ + "static/media/1373.ba565b1b.png";